module.exports = __webpack_public_path__ + "img/store-icons-apple.79fa9a9c.svg";